import { PageHeader } from "@/components/PageHeader";
import { PageShell } from "@/components/PageShell";
import { getActionMutationOptions } from "@/setup/frontend/api/getActionMutationOptions";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { useParams } from "react-router";

export default function CaregiverFilePreviewPage() {
	const queryClient = useQueryClient();
	const { id, fileId } = useParams();

	const [url, setUrl] = useState<string | undefined>(undefined);
	const options = getActionMutationOptions("getCaregiverFileDownloadLink", {});
	const mutation = useMutation({
		...options,
		mutationFn: ({ id, inline }) =>
			options.mutationFn!({ id, inline }).then((res) => {
				return res;
			}),
		onSuccess: (data) => {
			setUrl(data.url);
		},
	});

	useEffect(() => {
		mutation.mutate({ id: Number(fileId), inline: true });
	}, [fileId]);

	return (
		<PageShell
			header={
				<PageHeader
					title="Caregiver File Preview"
					breadcrumbs={[
						{
							href: `/caregivers/${id}/profile`,
							title: "Caregiver",
						},
						{
							href: `/caregivers/${id}/files/${fileId}`,
							title: "Caregiver File",
						},
					]}
				/>
			}
		>
			{url?.includes(".pdf") ? (
				<iframe
					src={url}
					title="Caregiver File Preview"
					style={{ width: "100%", height: "100%" }}
				/>
			) : (
				<img
					src={url}
					alt="Caregiver File Preview"
					style={{
						width: "100%",
						height: "100%",
						border: "none",
						objectFit: "contain",
					}}
				/>
			)}
		</PageShell>
	);
}
